import { gql, useMutation } from "@apollo/client";

export const PRINT_SELECTED_TAGS = gql`
    mutation PrintSelectedTags($items: [BagPrintItemInput!]!, $localTime: String, $timeZone: String) {
        printSelectedTags(items: $items, localTime: $localTime, timeZone: $timeZone) {
            success
            message
            pdfBase64
        }
    }
`;

export const DISCARD_SELECTED_TAGS = gql`
    mutation DiscardSelectedTags($ids: [String!]!) {
        discardSelectedTags(ids: $ids) {
            success
            message
        }
    }
`;

export interface BagPrintItem {
    bagId: string;
    copies: number;
    /** 从批次上打印时带：正在打印的那个批次 id；列表打印不传（后端回退物理当前批次） */
    batchId?: string;
}

export interface PrintSelectedTagsResponse {
    printSelectedTags: {
        success: boolean;
        message: string;
        pdfBase64: string | null;
    };
}

interface BatchOperationResponse {
    success: boolean;
    message: string;
}



export const useDiscardSelectedTags = () => {
    return useMutation<{ discardSelectedTags: BatchOperationResponse }, { ids: string[] }>(DISCARD_SELECTED_TAGS);
};

export const REOPEN_SELECTED_TAGS = gql`
    mutation ReopenSelectedTags($ids: [String!]!) {
        reopenSelectedTags(ids: $ids) {
            success
            message
        }
    }
`;

export const useReopenSelectedTags = () => {
    return useMutation<{ reopenSelectedTags: BatchOperationResponse }, { ids: string[] }>(REOPEN_SELECTED_TAGS);
};